import { ATTACHED_FILE_TYPE } from '@/api/type/commonTypes';
import { Images } from '@/assets';
import { FileTransferService } from '@/libs/r2-service-client';
import { fonts } from '@/theme/fonts';
import { formatFileSize } from '@/utils/file/formatFileSize';
import { useCallback } from 'react';
import styled from 'styled-components';

interface BusinessFileListProps {
  fileList: ATTACHED_FILE_TYPE[];
}

const BusinessFileList = ({ fileList }: BusinessFileListProps) => {
  const onClickDownload = useCallback(
    (item: ATTACHED_FILE_TYPE) => () => {
      try {
        const a = document.createElement('a');
        a.href = FileTransferService.getDownloadUri(item.id);
        a.download = item.name;
        a.click();
      } catch (error) {
        console.error('다운로드 실패', error);
      }
    },
    []
  );

  return (
    <ListBox>
      {fileList.length > 0 &&
        fileList.map((item) => (
          <UploadItem key={item.id}>
            <FileName>{item.name}</FileName>
            <DeleteWrap>
              <FileName>{formatFileSize(item.size)}</FileName>
              <ImgButton onClick={onClickDownload(item)} />
            </DeleteWrap>
          </UploadItem>
        ))}
    </ListBox>
  );
};

export default BusinessFileList;

const ListBox = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;
  overflow-y: auto;
  max-width: 312px;
  height: 100%;
`;

const UploadItem = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 6px 15px;
  flex-shrink: 0;
  width: calc(100% - 30px);
`;

const FileName = styled.div`
  font-family: ${fonts.family.poppins};
  font-size: 16px;
  line-height: 120%;
  color: #000000;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DeleteWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const ImgButton = styled.button`
  width: 26px;
  height: 17px;
  background-position: center;
  background-size: cover;
  background-image: url(${Images.DownloadIcon});
`;
